import { Modal } from "../../../components";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import Captcha from "../../../screens/BuscarInfracciones/Captcha";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import MapaDePuntos from "../../../screens/MapaDePuntos";
import { format, parseISO } from "date-fns";
import MapaCamara from "./components/MapaCamara";
import { Tab, Tabs } from "@mui/material";
import { useContext, useState } from "react";
import Incidencias from "./components/Incidencias";
import { UserContext } from "../../../context";
import Estadisticas from "./components/Estadisticas";

const ModalInfoCamara = (props) => {
  const { camaras, setCamaras } = props;
  const { actions: ua } = useContext(UserContext);
  const [value, setValue] = useState("informacion_general");
  const [incidencias, setIncidencias] = useState({
    data: null,
    is_loading: false,
    agregar_incidencia: false,
  });
  const { modals, handlerModal } = useGeneralAppStore();

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Modal
        show={modals.includes("info_camara")}
        size={"lg"}
        onHide={() => {
          handlerModal({ modal: false, modalName: "info_camara" });
          setCamaras((prevState) => ({
            ...prevState,
            camara_seleccionada: null,
          }));
        }}
        title={() => `Cámara ${camaras?.camara_seleccionada?.numero_serie}`}
      >
        <Tabs
          className="mb-4"
          value={value}
          onChange={handleTabChange}
          sx={{
            "& .MuiTabs-indicator": { backgroundColor: "#1334C9" },
          }}
        >
          <Tab
            sx={{
              color: "#1334C9",
              "&.Mui-selected": { color: "#1334C9" },
              fontFamily: "'Hind', sans-serif",
              fontWeight: "bolder",
              fontSize: "1rem",
              textTransform: "uppercase",
              letterSpacing: "normal",
              // paddingX: "0",
              // marginRight: "rem",
            }}
            value="informacion_general"
            label="Información General"
          />
          {ua.hasPermission("camaras.view.incidencias") && (
            <Tab
              sx={{
                color: "#1334C9",
                "&.Mui-selected": { color: "#1334C9" },
                fontFamily: "'Hind', sans-serif",
                fontWeight: "bolder",
                fontSize: "1rem",
                textTransform: "uppercase",
                letterSpacing: "normal",
                // paddingX: "0",
                // marginX: "1rem",
              }}
              value="estadisticas"
              label="Estadísticas"
            />
          )}
          {ua.hasPermission("camaras.view.incidencias") && (
            <Tab
              sx={{
                color: "#1334C9",
                "&.Mui-selected": { color: "#1334C9" },
                fontFamily: "'Hind', sans-serif",
                fontWeight: "bolder",
                fontSize: "1rem",
                textTransform: "uppercase",
                letterSpacing: "normal",
                // paddingX: "0",
                // marginX: "1rem",
              }}
              value="incidencias"
              label="Incidencias"
            />
          )}
        </Tabs>

        {value === "informacion_general" ? (
          <div>
            <ul>
              <li>Número de Serie: {camaras?.camara_seleccionada?.numero_serie}</li>
              <li>Equipo: {camaras?.camara_seleccionada?.equipo}</li>
              <li>Modelo: {camaras?.camara_seleccionada?.modelo}</li>
              <li>Lugar: {camaras?.camara_seleccionada?.lugar}</li>
              <li>Latitud: {camaras?.camara_seleccionada?.latitud}</li>
              <li>Longitud: {camaras?.camara_seleccionada?.longitud}</li>
              <li>Fecha de colocación: {camaras?.camara_seleccionada?.fecha_colocacion}</li>
              <li>
                Cantidad: {camaras?.camara_seleccionada?.infracciones_count} infracciones
                {camaras.filtrar_por_fecha && camaras.fecha_inicio && camaras.fecha_fin
                  ? ` desde el ${format(parseISO(camaras.fecha_inicio), "dd/MM/yyyy")} hasta el ${format(parseISO(camaras.fecha_fin), "dd/MM/yyyy")}`
                  : null}
              </li>
            </ul>
            <MapaCamara camara={camaras?.camara_seleccionada} />
          </div>
        ) : value === "incidencias" && ua.hasPermission("camaras.view.incidencias") ? (
          <div>
            <Incidencias
              camara_id={camaras?.camara_seleccionada?.id}
              incidencias={incidencias}
              setIncidencias={setIncidencias}
            />
          </div>
        ) : value === "estadisticas" && ua.hasPermission("camaras.view.incidencias") ? (
          <div>
            <Estadisticas camara={camaras?.camara_seleccionada} />
          </div>
        ) : null}
      </Modal>
    </>
  );
};
export default ModalInfoCamara;
